
import { DurationUnit, RepeatUnit, ScheduleAction } from "../../enums/DRCXEnums";
import { IDRCXScheduleDTO } from "./DRCXScheduleDTO";

export class DRCXScheduleModel {
    public originalStartTime: Date | undefined;
    public originalEndTime: Date | undefined;
    public currentStartTime: Date | undefined;
    public currentEndTime: Date | undefined;
    public duration: number = 0;
    public durationUnit: DurationUnit | undefined;
    public repeatUnit: RepeatUnit | undefined;
    public repeatValue: number = 0;
    public timezone: string | undefined;

    public preScheduleAction?: ScheduleAction = ScheduleAction.Ignore;
    public activeScheduleAction?: ScheduleAction = ScheduleAction.Ignore;
    public postScheduleAction?: ScheduleAction = ScheduleAction.Ignore;

    constructor(dto?: IDRCXScheduleDTO) {
        if (dto) {
            if (typeof dto.originalStartTime !== "undefined") {
                this.originalStartTime = new Date(dto.originalStartTime);
            }
            if (typeof dto.originalEndTime !== "undefined") {
                this.originalEndTime = new Date(dto.originalEndTime);
            }
            if (typeof dto.currentStartTime !== "undefined") {
                this.currentStartTime = new Date(dto.currentStartTime);
            }
            if (typeof dto.currentEndTime !== "undefined") {
                this.currentEndTime = new Date(dto.currentEndTime);
            }
            if (typeof dto.duration !== "undefined") {
                this.duration = dto.duration;
            }
            if (typeof dto.durationUnit !== "undefined") {
                this.durationUnit = dto.durationUnit;
            }
            if (typeof dto.repeatUnit !== "undefined") {
                this.repeatUnit = dto.repeatUnit;
            }
            if (typeof dto.repeatValue !== "undefined") {
                this.repeatValue = dto.repeatValue;
            }
            if (typeof dto.timezone !== "undefined") {
                this.timezone = dto.timezone;
            }
            if (typeof dto.preScheduleAction !== "undefined") {
                this.preScheduleAction = dto.preScheduleAction;
            }
            if (typeof dto.activeScheduleAction !== "undefined") {
                this.activeScheduleAction = dto.activeScheduleAction;
            }
            if (typeof dto.postScheduleAction !== "undefined") {
                this.postScheduleAction = dto.postScheduleAction;
            }
        }
    }

    public toDTO(): IDRCXScheduleDTO {
        return {
            originalStartTime: this.originalStartTime?.toISOString(),
            originalEndTime: this.originalEndTime?.toISOString(),
            currentStartTime: this.currentStartTime?.toISOString(),
            currentEndTime: this.currentEndTime?.toISOString(),
            duration: this.duration,
            durationUnit: this.durationUnit,
            repeatUnit: this.repeatUnit,
            repeatValue: this.repeatValue,
            timezone: this.timezone,
            preScheduleAction: this.preScheduleAction,
            activeScheduleAction: this.activeScheduleAction,
            postScheduleAction: this.postScheduleAction
        };
    }
}
